import React from "react";

interface ScheduleSkeletonProps {
  isDarkMode?: boolean;
}

export default function ScheduleSkeleton({
  isDarkMode = false,
}: ScheduleSkeletonProps) {
  const bgMain = isDarkMode ? "bg-gray-900" : "bg-white";
  const bgPanel = isDarkMode ? "bg-gray-800" : "bg-white";
  const borderCol = isDarkMode ? "border-gray-700" : "border-gray-200";
  const muted = isDarkMode ? "bg-gray-700" : "bg-gray-200";
  const mutedSoft = isDarkMode ? "bg-gray-600" : "bg-gray-100";

  return (
    <div className={`flex-1 flex h-screen ${bgMain}`}>
      {/* Left Sidebar */}
      <div
        className={`w-80 border-r p-6 overflow-y-auto max-h-screen ${borderCol} ${isDarkMode ? "bg-gray-800" : "bg-gray-50"} border `}
      >
        <div className="space-y-6">
          <div className={`border rounded-lg p-4 ${borderCol} ${bgPanel}`}>
            <div className={`h-6 w-24 rounded ${muted}`} />
            <div className="grid grid-cols-7 gap-2 mt-4">
              {Array.from({ length: 28 }).map((_, i) => (
                <div key={i} className={`h-6 rounded ${mutedSoft}`} />
              ))}
            </div>
          </div>

          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className={`border rounded-lg p-4 space-y-3 ${borderCol} ${bgPanel}`}
            >
              <div className={`h-5 w-28 rounded ${muted}`} />
              <div className="space-y-2">
                {[...Array(3)].map((_, j) => (
                  <div key={j} className="flex items-center gap-2">
                    <div className={`h-4 w-4 rounded ${mutedSoft}`} />
                    <div className={`h-4 w-40 rounded ${mutedSoft}`} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 max-h-screen overflow-hidden ">
        {/* Header */}
        <div className={`border-b p-6 ${borderCol} ${bgPanel}`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className={`h-8 w-8 rounded ${muted}`} />
              <div className={`h-8 w-8 rounded ${muted}`} />
            </div>
            <div className={`h-6 w-64 rounded ${muted}`} />
            <div className="flex items-center gap-2">
              <div className={`h-8 w-16 rounded ${muted}`} />
              <div className={`h-8 w-16 rounded ${muted}`} />
              <div className={`h-8 w-16 rounded ${muted}`} />
            </div>
          </div>
        </div>

        {/* Body grid */}
        <CalendarSkeleton isDarkMode={isDarkMode} />
      </div>
    </div>
  );
}

export function CalendarSkeleton({
  isDarkMode = false,
}: ScheduleSkeletonProps) {
  const muted = isDarkMode ? "bg-gray-700" : "bg-gray-200";
  const mutedSoft = isDarkMode ? "bg-gray-600" : "bg-gray-100";

  return (
    <div className={`flex-1 p-6 ${isDarkMode ? "bg-gray-900" : ""}`}>
      {/* Day headers */}
      <div className="grid grid-cols-7 gap-1 mb-1">
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className={`h-8 rounded ${mutedSoft}`} />
        ))}
      </div>

      {/* Calendar cells */}
      <div
        className={`grid grid-cols-7 gap-1 ${isDarkMode ? "bg-gray-600" : "bg-gray-200"}`}
      >
        {Array.from({ length: 35 }).map((_, i) => (
          <div
            key={i}
            className={`${isDarkMode ? "bg-gray-800" : "bg-gray-50"} h-36 p-2`}
          >
            <div className="flex flex-col gap-2">
              <div className={`h-4 w-10 rounded ${muted}`} />
              <div className={`h-5 w-full rounded ${mutedSoft}`} />
              <div className={`h-5 w-3/4 rounded ${mutedSoft}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
